<div class="box-table">

	<span class="title-accordion" [class.active]="!isCollapsed" (click)="isCollapsed = !isCollapsed"
		(keypress)="isCollapsed = !isCollapsed">
		{{ labels().LLD_RECAP_TITLE }}
		<div class="fake-material-icon icon-expand expand"></div>
	</span>

	<table aria-label="lld measures" class="table" [ngbCollapse]="isCollapsed">
		<thead>
			<tr>
				<th></th>
				<th>{{ labels().LLD_RECAP_LENGTH_HEADER }} <br />
					({{ (isLeft ? sideEnum.Left : sideEnum.Right) | anatomicalSideLabel }})</th>
				<th>{{ labels().LLD_RECAP_CL_LENGTH_HEADER }} <br />
					({{ (isLeft ? sideEnum.Right : sideEnum.Left) | anatomicalSideLabel }})</th>
				<th>{{ labels().LLD_RECAP_LLD_HEADER }}</th>
			</tr>
		</thead>
		<tbody>
			@if (isLongLeg) {
			<tr>
				<td>{{ labels().LLD_RECAP_LONGLEG }}</td>
				<td>{{ eocMeasures?.eoc_ap_fullLength }}</td>
				<td>{{ defCLMeasures?.def_ap_fullLength_ctrlateral }}</td>
				<td>{{ longlegLLD_eoc }}</td>
			</tr>
			}
			@if (isLongLeg || isFemur) {
			<tr>
				<td>{{ labels().LLD_RECAP_FEMUR }}</td>
				<td>{{ eocMeasures?.eoc_ap_femurLength }}</td>
				<td>{{ defCLMeasures?.def_ap_femurLength_ctrlateral }}</td>
				<td>{{ femurLLD_eoc }}</td>
			</tr>
			}
			@if (isLongLeg || isTibia) {
			<tr>
				<td>{{ labels().LLD_RECAP_TIBIA }}</td>
				<td>{{ eocMeasures?.eoc_ap_tibiaLength }}</td>
				<td>{{ defCLMeasures?.def_ap_tibiaLength_ctrlateral }}</td>
				<td>{{ tibiaLLD_eoc }}</td>
			</tr>
			}
			@if (isLongLeg) {
			<tr>
				<td>{{ labels().LLD_RECAP_FEMUR_TIBIA }}</td>
				<td>{{ trueLength_eoc }}</td>
				<td>{{ trueLengthCL }}</td>
				<td>{{ trueLengthLLD_eoc }}</td>
			</tr>
			}
		</tbody>
	</table>

</div>